<template>
  <div class="f1-race-track">
    <ul class="f1-race-track__options" v-if="showFilters">
      <li :class="checkboxActiveClass(sector)">
        <input type="checkbox" id="f1-race-track__sector" class="f1-race-track__input" v-model="sector" />
        <div class="f1-race-track__input-fake"></div>
        <label for="f1-race-track__sector" class="f1-race-track__label">
          {{ $t('raceTrack.sector') }}
        </label>
      </li>
      <li :class="checkboxActiveClass(drs)">
        <input type="checkbox" id="f1-race-track__drs" class="f1-race-track__input" v-model="drs" />
        <div class="f1-race-track__input-fake"></div>
        <label for="f1-race-track__drs" class="f1-race-track__label">
          {{ $t('raceTrack.drs') }}
        </label>
      </li>
      <li :class="checkboxActiveClass(turns)">
        <input type="checkbox" id="f1-race-track__turns" class="f1-race-track__input" v-model="turns" />
        <div class="f1-race-track__input-fake"></div>
        <label for="f1-race-track__turns" class="f1-race-track__label">
          {{ $t('raceTrack.turns') }}
        </label>
      </li>
    </ul>
    <race-track-abu-dhabi :class="trackHighlightsClass" v-if="showThisTrack('291')"/>
    <race-track-australia :class="trackHighlightsClass" v-if="showThisTrack('1')"/>
    <race-track-austria :class="trackHighlightsClass" v-if="showThisTrack('20')"/>
    <race-track-azerbaijan :class="trackHighlightsClass" v-if="showThisTrack('723')"/>
    <race-track-bahrain :class="trackHighlightsClass" v-if="showThisTrack('3')"/>
    <race-track-belgium :class="trackHighlightsClass" v-if="showThisTrack('14')"/>
    <race-track-brazil :class="trackHighlightsClass" v-if="showThisTrack('18')"/>
    <race-track-canada :class="trackHighlightsClass" v-if="showThisTrack('8')"/>
    <race-track-china :class="trackHighlightsClass" v-if="showThisTrack('16')"/>
    <race-track-france :class="trackHighlightsClass" v-if="showThisTrack('85')"/>
    <race-track-germany :class="trackHighlightsClass" v-if="showThisTrack('12')"/>
    <race-track-hungary :class="trackHighlightsClass" v-if="showThisTrack('13')"/>
    <race-track-italy :class="trackHighlightsClass" v-if="showThisTrack('15')"/>
    <race-track-japan :class="trackHighlightsClass" v-if="showThisTrack('17')"/>
    <race-track-mexico :class="trackHighlightsClass" v-if="showThisTrack('78')"/>
    <race-track-monaco :class="trackHighlightsClass" v-if="showThisTrack('6')"/>
    <race-track-russia :class="trackHighlightsClass" v-if="showThisTrack('643')"/>
    <race-track-singapore :class="trackHighlightsClass" v-if="showThisTrack('235')"/>
    <race-track-spain :class="trackHighlightsClass" v-if="showThisTrack('5')"/>
    <race-track-united-kingdom :class="trackHighlightsClass" v-if="showThisTrack('11')"/>
    <race-track-united-states :class="trackHighlightsClass" v-if="showThisTrack('347')"/>
    <race-track-netherlands :class="trackHighlightsClass" v-if="showThisTrack('26')"/>
    <race-track-vietnam :class="trackHighlightsClass" v-if="showThisTrack('825')"/>
    <race-track-italy-mugello :class="trackHighlightsClass" v-if="showThisTrack('231')"/>
    <race-track-germany-nuerburg :class="trackHighlightsClass" v-if="showThisTrack('7')"/>
    <race-track-portugal :class="trackHighlightsClass" v-if="showThisTrack('284')"/>
    <race-track-san-marino :class="trackHighlightsClass" v-if="showThisTrack('4')"/>
    <race-track-turkey :class="trackHighlightsClass" v-if="showThisTrack('19')"/>
  </div>
</template>

<script>
const abuDhabiTrack = () => import('../assets/tracks/MF1_2019_ABUDHABI.svg');
const australiaTrack = () => import('../assets/tracks/MF1_2019_AUSTRALIA.svg');
const austriaTrack = () => import('../assets/tracks/MF1_2019_AUSTRIA.svg');
const azerbaijanTrack = () => import('../assets/tracks/MF1_2019_AZER.svg');
const bahrainTrack = () => import('../assets/tracks/MF1_2019_BAHRAIN.svg');
const belgiumTrack = () => import('../assets/tracks/MF1_2019_BELGIUM.svg');
const brazilTrack = () => import('../assets/tracks/MF1_2019_BRAZIL.svg');
const canadaTrack = () => import('../assets/tracks/MF1_2019_CANADA.svg');
const chinaTrack = () => import('../assets/tracks/MF1_2019_CHINA.svg');
const franceTrack = () => import('../assets/tracks/MF1_2019_FRANCE.svg');
const germanyTrack = () => import('../assets/tracks/MF1_2019_GERMAN.svg');
const hungaryTrack = () => import('../assets/tracks/MF1_2019_HUNGARY.svg');
const italyTrack = () => import('../assets/tracks/MF1_2019_ITALY.svg');
const japanTrack = () => import('../assets/tracks/MF1_2019_JAPAN.svg');
const mexicoTrack = () => import('../assets/tracks/MF1_2019_MEXICO.svg');
const monacoTrack = () => import('../assets/tracks/MF1_2019_MONACO.svg');
const russiaTrack = () => import('../assets/tracks/MF1_2019_RUSSIA.svg');
const singaporeTrack = () => import('../assets/tracks/MF1_2019_SINGAPORE.svg');
const spainTrack = () => import('../assets/tracks/MF1_2019_SPAIN.svg');
const unitedKingdomTrack = () => import('../assets/tracks/MF1_2019_GBR.svg');
const unitedStatesTrack = () => import('../assets/tracks/MF1_2019_USA.svg');
const netherlandsTrack = () => import('../assets/tracks/MF1_2020_NETHERLANDS.svg');
const vietnamTrack = () => import('../assets/tracks/MF1_2020_VIETNAM.svg');
const italyMugelloTrack = () => import('../assets/tracks/200813_MUGELLO_16x9.svg');
const germanyNuerburgTrack = () => import('../assets/tracks/200813_NURBURGRING_16x9.svg');
const portugalTrack = () => import('../assets/tracks/200813_PORTIMAO_16x9.svg');
const sanMarinoTrack = () => import('../assets/tracks/200826_IMOLA_16x9.svg');
const turkeyTrack = () => import('../assets/tracks/200826_TURKEY_16x9.svg');

export default {
  name: 'raceTrack',
  components: {
    'race-track-abu-dhabi': abuDhabiTrack,
    'race-track-australia': australiaTrack,
    'race-track-austria': austriaTrack,
    'race-track-azerbaijan': azerbaijanTrack,
    'race-track-bahrain': bahrainTrack,
    'race-track-belgium': belgiumTrack,
    'race-track-brazil': brazilTrack,
    'race-track-canada': canadaTrack,
    'race-track-china': chinaTrack,
    'race-track-france': franceTrack,
    'race-track-germany': germanyTrack,
    'race-track-hungary': hungaryTrack,
    'race-track-italy': italyTrack,
    'race-track-japan': japanTrack,
    'race-track-mexico': mexicoTrack,
    'race-track-monaco': monacoTrack,
    'race-track-russia': russiaTrack,
    'race-track-singapore': singaporeTrack,
    'race-track-spain': spainTrack,
    'race-track-united-kingdom': unitedKingdomTrack,
    'race-track-united-states': unitedStatesTrack,
    'race-track-netherlands': netherlandsTrack,
    'race-track-vietnam': vietnamTrack,
    'race-track-italy-mugello': italyMugelloTrack,
    'race-track-germany-nuerburg': germanyNuerburgTrack,
    'race-track-portugal': portugalTrack,
    'race-track-san-marino': sanMarinoTrack,
    'race-track-turkey': turkeyTrack,
  },
  props: {
    trackName: {
      type: String,
      required: true,
    },
    showFilters: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      sector: false,
      drs: false,
      turns: false,
    };
  },
  methods: {
    checkboxActiveClass (bool) {
      if (bool) {
        return 'f1-race-track__checkbox f1-race-track__checkbox--active';
      }
      return 'f1-race-track__checkbox';
    },
    showThisTrack (trackName) {
      return trackName === this.trackName;
    },
  },
  computed: {
    trackHighlightsClass () {
      const classes = ['f1-race-track__image'];

      if (this.sector) {
        classes.push('sector-active');
      }

      if (this.drs) {
        classes.push('drs-active');
      }

      if (this.turns) {
        classes.push('turns-active');
      }

      if (this.showFilters) {
        classes.push('start-active');
      }

      return classes;
    },
  },
};
</script>

<style lang="scss">
  @import "../styles/components/raceTrack";
</style>
